// Avatar color combinations
const avatarColors = [
  { bg: 'bg-[#dbeafe]', text: 'text-[#155dfc]' },
  { bg: 'bg-[#dcfce7]', text: 'text-[#00a63e]' },
  { bg: 'bg-[#fef3c7]', text: 'text-[#d97706]' },
  { bg: 'bg-[#fce7f3]', text: 'text-[#db2777]' },
  { bg: 'bg-[#e0e7ff]', text: 'text-[#4f46e5]' },
]

/**
 * Generate initials from a primary string with a fallback.
 * Example: getInitials("Jane Smith", "jane@email.com") → "JS"
 */
export function getInitials(
  primary: string | null | undefined,
  fallback: string | null | undefined
): string {
  if (primary) {
    const parts = primary.trim().split(/\s+/)
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase()
    }
    return primary.slice(0, 2).toUpperCase()
  }
  if (fallback) {
    return fallback.slice(0, 2).toUpperCase()
  }
  return '??'
}

/**
 * Get a deterministic avatar color based on user ID.
 */
export function getAvatarColor(id: string | number) {
  const index =
    typeof id === 'string'
      ? id.charCodeAt(0) % avatarColors.length
      : id % avatarColors.length
  return avatarColors[index]
}
